import React from "react";

export function CreateFileNameOptions(fileNames){
    let tmpFileNameOptions = [];
    for(let i = 0; i < fileNames.length; i++) {
        tmpFileNameOptions.push(
            {
                key: i,
                text: fileNames[i],
                value: fileNames[i]
            }
        )
    }
    return tmpFileNameOptions;
}
